// src/pages/About.jsx
import React from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaCheckCircle } from "react-icons/fa";
import logoWhite from "../asset/logowhite.png";
import logoColor from "../asset/logo.png"; // your main colored logo (blue/orange)

const About = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br bg-[#001f3f] dark:bg-[#111827] text-white py-24 overflow-hidden">
        <div className="relative max-w-7xl mx-auto px-6 text-center text-white z-10">
          <h1 className="text-4xl md:text-6xl font-extrabold mb-6 leading-tight">
            About Skillara
          </h1>
          <p className="text-lg md:text-2xl max-w-4xl mx-auto opacity-95 font-light">
            Premium Online Training with the Most Effective Learning System
          </p>
        </div>
      </section>

      {/* Main Content - Who We Are */}
      <section className="py-16 px-6 bg-gray-50 dark:bg-gray-900">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 dark:text-white mb-8">
            Empowering Professionals for Accelerated Career Growth
          </h2>
          <p className="text-lg text-gray-700 dark:text-gray-300 leading-relaxed max-w-4xl mx-auto">
            Skillara is a premium online training provider with the most effective learning system. 
            We help professionals learn cutting-edge technologies through expert-led courses, 
            hands-on projects, live mentorship, and personalized guidance — ensuring you don't just learn, 
            but master skills that top companies hire for.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
            {/* Card 1 */}
            <div className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-700 hover:shadow-2xl transition-shadow">
              <FaCheckCircle className="text-6xl text-green-500 mx-auto mb-5" />
              <h3 className="text-2xl font-bold text-blue-900 dark:text-white mb-3">
                Industry-Relevant Curriculum
              </h3>
              <p className="text-gray-600 dark:text-gray-400">
                Designed and updated by experts working at MAANG & Fortune 500 companies.
              </p>
            </div>

            {/* Card 2 */}
            <div className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-700 hover:shadow-2xl transition-shadow">
              <FaCheckCircle className="text-6xl text-blue-500 mx-auto mb-5" />
              <h3 className="text-2xl font-bold text-blue-900 dark:text-white mb-3">
                Live Mentorship & Projects
              </h3>
              <p className="text-gray-600 dark:text-gray-400">
                Real-time doubt clearing, 1:1 guidance, and real-world capstone projects.
              </p>
            </div>

            {/* Card 3 */}
            <div className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-700 hover:shadow-2xl transition-shadow">
              <FaCheckCircle className="text-6xl text-orange-500 mx-auto mb-5" />
              <h3 className="text-2xl font-bold text-blue-900 dark:text-white mb-3">
                Job-Ready Certification
              </h3>
              <p className="text-gray-600 dark:text-gray-400">
                Globally recognized certificates + placement assistance, resume building & mock interviews.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Info Section - Clean & Centered */}
      <section className="py-20 px-6 bg-white dark:bg-gray-800">
        <div className="max-w-4xl mx-auto text-center">
          {/* Dynamic Logo - White in dark, Color in light */}
          <img
            src={logoWhite}
            alt="Skillara Logo White"
            className="h-14 mx-auto mb-10 block dark:block hidden"
          />
          <img
            src={logoColor}
            alt="Skillara Logo"
            className="h-14 mx-auto mb-10 hidden dark:hidden"
          />

          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 dark:text-white mb-10">
            Visit Us
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-5xl mx-auto">
            <div className="flex flex-col items-center">
              <FaMapMarkerAlt className="text-4xl text-blue-600 dark:text-blue-400 mb-4" />
              <h4 className="font-semibold text-lg text-gray-800 dark:text-gray-200 mb-2">
                Office Address
              </h4>
              <p className="text-gray-600 dark:text-gray-400 text-center text-sm leading-relaxed">
                4th Floor, MKR Enclave,<br />
                Kamayyathopu Pantakaluva Road,<br />
                NTR Marg, Kanuru,<br />
                Vijayawada, Andhra Pradesh 520007
              </p>
            </div>

            <div className="flex flex-col items-center">
              <FaPhoneAlt className="text-4xl text-green-600 dark:text-green-400 mb-4" />
              <h4 className="font-semibold text-lg text-gray-800 dark:text-gray-200 mb-2">
                Call Us
              </h4>
              <p className="text-gray-600 dark:text-gray-400">
                +1 833 564 3321 <span className="text-sm block">(Toll Free)</span>
              </p>
            </div>

            <div className="flex flex-col items-center">
              <FaEnvelope className="text-4xl text-purple-600 dark:text-purple-400 mb-4" />
              <h4 className="font-semibold text-lg text-gray-800 dark:text-gray-200 mb-2">
                Email Us
              </h4>
              <p className="text-gray-600 dark:text-gray-400 underline-offset-4">
                contact@Skillara.org
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;